import { render, staticRenderFns } from "./bigMap.vue?vue&type=template&id=089cede2&scoped=true"
import script from "./bigMap.vue?vue&type=script&lang=js"
export * from "./bigMap.vue?vue&type=script&lang=js"
import style0 from "./bigMap.vue?vue&type=style&index=0&id=089cede2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089cede2",
  null
  
)

export default component.exports